import {Strophe} from "strophe.js";
import {Friend} from "@/entity/Friend";
import {Message} from "@/entity/Message";
import {AuthTokenDto} from "@/oauth/AuthTokenDto";
import {SecurityUtils} from "@/oauth/SecurityUtils";
import {Group} from "@/entity/Group";
import {GroupMessage} from "@/entity/GroupMessage";
import GroupChat from "@/views/GroupChat.vue";
import ChatPage from "@/views/ChatPage.vue";
import {UserDto} from "@/oauth/UserDto";
import EbyChatPage from "@/views/EbyChatPage.vue";
import KeShangSelect2 from "@/views/KeShangSelect2.vue";
import {KsChatUserDto} from "@/dto/KsChatUserDto";
import {KsChatUser} from "@/entity/KsChatUser";

export class XmppUtils {
    at = AuthTokenDto;
    su = SecurityUtils;
    username = SecurityUtils.getLoginUser().username;
    ksChatUsers: KsChatUser[] = [];
    static username = ''
    static jid = ''
    static connection = new Strophe.Connection('https://msg.yong-gang.cn/http-bind/');
    static friends: Friend[] = [];
    static groups: Group[] = [];
    groupMessage: GroupMessage[] = [];
    message: Message[] = [];


    public async xmppLogin() {
        XmppUtils.username = this.username;
        await this.findAllGroups();

        XmppUtils.connection.connect(this.username + '@rtc1', AuthTokenDto.getFromStorage().access_token, async (status, condition) => {
            if (status == Strophe.Status.CONNFAIL) {
                console.log("连接失败！");
            } else if (status == Strophe.Status.AUTHFAIL) {
                console.log("登录失败！");
            } else if (status == Strophe.Status.DISCONNECTED) {
                console.log("连接断开！正在重新连接！");
                XmppUtils.friends = [];
                XmppUtils.groups = [];
                await this.xmppLogin();
            } else if (status == Strophe.Status.CONNECTED) {
                console.log("连接成功，可以开始聊天了！");
                // console.log('pubsub', XmppUtils.connection)
                const xmppJid = XmppUtils.connection.jid;
                const b = xmppJid.lastIndexOf('/');
                const xmppJid1 = xmppJid.substring(b + 1, xmppJid.length);
                XmppUtils.jid = xmppJid1;
                this.findFriends();
                XmppUtils.connection.addHandler(this.onMessage, '', 'message', '', '', '');
                XmppUtils.connection.send($pres().tree());
            }
            // console.log(xmppJid1);
        });
    }

    /**
     * 收到消息
     */

    async onMessage(msg: Element) {
        // console.log(msg);
        // console.log('===============')
        // 解析出<message>的from、type属性，以及body子元素
        const from = msg.getAttribute('from');
        const to = msg.getAttribute('to');
        const type = msg.getAttribute('type');
        const types = msg.getAttribute('types');
        const filePreviewUrl = msg.getAttribute('filePreviewUrl');
        const fileDownloadUrl = msg.getAttribute('fileDownloadUrl');
        const elems = msg.getElementsByTagName('body');
        const received = msg.getElementsByTagName('received');
        const messageReceived = received[0];
        const receiveJid = from as string;
        const sendJid = to as string;
        const body = elems[0];

        //一对一聊天回执消息
        if (type === 'normal' && from === 'rtc1') {
            const messageReceivedBody = Strophe.getText(messageReceived);
            setTimeout(() => {
                ChatPage.messages.forEach(value => {
                    if (!value.isSended) {
                        if (value.mes == messageReceivedBody) {
                            value.isSended = true;
                            localStorage.setItem(XmppUtils.username + 'messages' + value.receiveJid.substring(0, 11), JSON.stringify(ChatPage.messages));
                        }
                    }
                });
            }, 200);
        }

        //是否已读消息
        if (type === 'headline' && Strophe.getText(body) === '#*已读#') {
            ChatPage.messages.forEach(value => {
                if (value.isSent === '') {
                    value.isRead = true;
                }
            });
            localStorage.setItem(XmppUtils.username + 'messages' + receiveJid.substring(0, 11), JSON.stringify(ChatPage.messages));
        }

        //收到一对一聊天消息
        else if (type == "chat" && elems.length > 0) {
            const message = new Message();
            const delayList = msg.querySelectorAll("delay");
            delayList.forEach(value => {
                if (value != null) {
                    const stamp = value.getAttribute("stamp") as string;
                    const data = new Date(stamp)
                    message.timeStamp = data.getTime();
                    message.time = Message.formatDate(data.getTime());
                }
            });
            //文件类型
            if (types) {
                message.type = types as string;
                message.filePreviewUrl = filePreviewUrl as string;
                message.fileDownloadUrl = fileDownloadUrl as string;
            }
            //消息时间显示
            if (ChatPage.messages.length > 0 && ChatPage.messages[ChatPage.messages.length - 1].timeStamp != null) {
                if (message.timeStamp - ChatPage.messages[ChatPage.messages.length - 1].timeStamp > 600000) {
                    message.isShowTime = true;
                }
            } else {
                message.isShowTime = true;
            }
            //初始化消息体
            message.mes = Strophe.getText(body);
            message.isSent = 'received';
            message.receiveJid = receiveJid.substring(0, 16);
            message.sendJid = sendJid.substring(0, 16);
            const friend = XmppUtils.friends.find(value => value.jid == receiveJid.substring(0, 16)) as Friend;
            message.avatarUrl = friend.avatarUrl;
            //取出本地消息并保存
            const item = localStorage.getItem(XmppUtils.username + 'messages' + receiveJid.substring(0, 11));
            if (XmppUtils.username !== receiveJid.substring(0, 11)) {
                if (item != null && item.length > 2) {
                    const messages = JSON.parse(item);
                    ChatPage.messages = messages;
                    ChatPage.messages.push(message);
                    window.postMessage('gundongtiao', '*')
                    EbyChatPage.messages = messages;
                    // console.log(this.message);
                    localStorage.setItem(XmppUtils.username + 'messages' + receiveJid.substring(0, 11), JSON.stringify(ChatPage.messages));
                } else {
                    ChatPage.messages.push(message);
                    EbyChatPage.messages.push(message);
                    localStorage.setItem(XmppUtils.username + 'messages' + receiveJid.substring(0, 11), JSON.stringify(ChatPage.messages));
                }
                //保存为最近联系人
                const recentlyFriend = KeShangSelect2.recentlyFriends.find(value => value.jid === receiveJid.substring(0, 16));
                const friend1 = XmppUtils.friends.find(value => value.jid === receiveJid.substring(0, 16));
                if (recentlyFriend == null && friend1 != null) {
                    KeShangSelect2.recentlyFriends.push(friend1);
                    localStorage.setItem(XmppUtils.username + 'recentlyFriends', JSON.stringify(KeShangSelect2.recentlyFriends));
                }
            }
        } else if (type == "groupchat" && elems.length > 0) {
            const from1 = from as string;
            const from2 = from1.substring(0, from1.indexOf("@"));
            const address = msg.querySelector("address");
            const delayList = msg.querySelectorAll("delay");
            const item = localStorage.getItem(XmppUtils.username + 'groupMessages' + from2);
            let return1 = false;

            delayList.forEach(value => {
                if (value != null) {
                    const stamp = value.getAttribute("stamp") as unknown as number;
                    const timeStamp = new Date(stamp).getTime();
                    if (item != null && item.length > 2) {
                        const groupMessages = JSON.parse(item) as GroupMessage[];
                        groupMessages.forEach(value => {
                            if (value.timeStamp === timeStamp) {
                                return1 = true;
                            }
                        });
                    }
                }
            });
            if (return1){
                return ;
            }
            if (address != null) {
                const address1 = address.getAttribute("jid") as string;
                if (address1 != XmppUtils.username + '@rtc1') {
                    const body = elems[0];
                    const groupMesg = new GroupMessage();
                    const delayList = msg.querySelectorAll("delay");
                    delayList.forEach(value => {
                        if (value != null) {
                            const stamp = value.getAttribute("stamp") as string;
                            const data = new Date(stamp)
                            groupMesg.timeStamp = data.getTime();
                            groupMesg.time = GroupMessage.formatDate(data.getTime());
                        }
                    });
                    groupMesg.mes = Strophe.getText(body);
                    groupMesg.isSent = 'received';
                    groupMesg.sendJid = XmppUtils.username + '@rtc1';
                    const receiveJid = from as string;
                    const a = receiveJid.indexOf('@');
                    window.postMessage('groupSlideDown', '*');
                    groupMesg.receiveJid = receiveJid.substring(0, a);
                    const user = await UserDto.findByUsername(address1.substring(0, 11));
                    groupMesg.avatarUrl = user.avatarUrl;
                    const friend = XmppUtils.friends.find(value => value.jid === address1);
                    if (friend != null) {
                        groupMesg.messageName = friend.name;
                    }
                    if (item != null && item.length > 2) {
                        const groupMessages = JSON.parse(item);
                        GroupChat.groupMessages = groupMessages;
                        GroupChat.groupMessages.push(groupMesg);
                        localStorage.setItem(XmppUtils.username + 'groupMessages' + from2, JSON.stringify(GroupChat.groupMessages));
                    } else {
                        GroupChat.groupMessages.push(groupMesg);
                        localStorage.setItem(XmppUtils.username + 'groupMessages' + from2, JSON.stringify(GroupChat.groupMessages));
                    }
                } else {
                    const body = elems[0];
                    const groupMesg = new GroupMessage();
                    const delayList = msg.querySelectorAll("delay");
                    delayList.forEach(value => {
                        if (value != null) {
                            const stamp = value.getAttribute("stamp") as string;
                            const data = new Date(stamp)
                            groupMesg.timeStamp = data.getTime();
                            groupMesg.time = GroupMessage.formatDate(data.getTime());
                        }
                    });
                    window.postMessage('groupSlideDown', '*');
                    groupMesg.mes = Strophe.getText(body);
                    groupMesg.sendJid = XmppUtils.username + '@rtc1';
                    const receiveJid = from as string;
                    const a = receiveJid.indexOf('@');
                    groupMesg.receiveJid = receiveJid.substring(0, a);
                    groupMesg.messageName = '我';
                    if (item != null && item.length > 2) {
                        const groupMessages = JSON.parse(item);
                        GroupChat.groupMessages = groupMessages;
                        GroupChat.groupMessages.push(groupMesg);
                        localStorage.setItem(XmppUtils.username + 'groupMessages' + from2, JSON.stringify(GroupChat.groupMessages));
                    } else {
                        const groupMessage: GroupMessage[] = [];
                        GroupChat.groupMessages.push(groupMesg);
                        localStorage.setItem(XmppUtils.username + 'groupMessages' + from2, JSON.stringify(GroupChat.groupMessages));
                    }
                }
            }
        }
        //每次收到消息以后都要进行下一次监听，如果不做这一步，就只能监听一次（未解决）
        return true;
    }


    //获取联系人和群聊列表
    findFriends() {
        const iq3 = $iq({type: 'set', xmlns: "jabber:client"})
            .c('enable', {xmlns: "urn:xmpp:carbons:2"});
        XmppUtils.connection.sendIQ(iq3);

        const iq = $iq({type: 'get', xmlns: "jabber:client"})
            .c('query', {xmlns: 'jabber:iq:roster'});
        XmppUtils.connection.sendIQ(iq, async (a) => {
            const itemList = a.querySelectorAll("item");
            XmppUtils.friends = [];
            for (const value of itemList) {
                if (value != null) {

                    const jid: string = value.getAttribute("jid") as string;
                    const name: string = value.getAttribute("name") as string;
                    const user = await UserDto.findByUsername(jid.substring(0, 11));
                    const avatarUrl = user.avatarUrl;
                    XmppUtils.friends.push(Friend.of({jid, name, avatarUrl}));
                    window.localStorage.setItem("friendList", JSON.stringify(XmppUtils.friends));
                }
            }
        });
        const iq1 = $iq({type: 'get', xmlns: 'jabber:client'})
            .c('blocklist', {xmlns: 'urn:xmpp:blocking'});
        XmppUtils.connection.sendIQ(iq1);

        const iq2 = $iq({type: 'get', xmlns: 'jabber:client'})
            .c('pubsub', {xmlns: 'http://jabber.org/protocol/pubsub'})
            .c('items', {node: 'storage:bookmarks'});
        XmppUtils.connection.sendIQ(iq2, (a) => {
            const itemList = a.querySelectorAll("conference");
            itemList.forEach(value => {
                if (value != null) {
                    const jid: string = value.getAttribute("jid") as string;
                    const name: string = value.getAttribute("name") as string;
                    // XmppUtils.groups.push(Group.of({jid, name}));
                    // localStorage.removeItem(XmppUtils.username + 'groupMessages' + name)
                    // this.loadingGroup(jid);
                }
            });
        });
        this.ksChatUsers.forEach(value => {
            this.loadingGroup(value.roomName + "@conference.rtc1");
            const id = value.groupId;
            const name = value.groupName;
            const roomName = value.roomName;
            const headPortrait = value.headPortrait;
            XmppUtils.groups.push(Group.of({id, name, roomName, headPortrait}))
        })
        console.log(XmppUtils.groups)
        this.joinChatRoom();
    }

    loadingGroup(jid: string) {
        const iq = $iq({type: 'get', to: jid, xmlns: "jabber:client"})
            .c('query', {xmlns: "http://jabber.org/protocol/disco#info"})
        // const b = new Strophe.Builder('presence', {
        //     to: jid + "/" + XmppUtils.username,
        //     xmlns: "jabber:client"
        // })
        //     .c('x', {xmlns: "http://jabber.org/protocol/muc"})
        const pres = $pres({
            to: jid + "/" + XmppUtils.jid,
            xmlns: "jabber:client",
        }).c('x', {xmlns: 'http://jabber.org/protocol/muc'}).tree();//群聊在线，在线了才能发消息
        const b1 = new Strophe.Builder('presence', {xmlns: "jabber:client"})
            .c('c', {hash: "sha-1", xmlns: "http://jabber.org/protocol/caps"})
            .c('x', {xmlns: "vcard-temp:x:update"})
            .c('photo');
        XmppUtils.connection.sendIQ(iq);
        XmppUtils.connection.send(pres);
        XmppUtils.connection.send(b1);
    }

    // ksChatUsers: Customer[] = [];
    // ksChatUsers: KsChatUser[] = [];

    async findAllGroups() {
        this.ksChatUsers = await KsChatUserDto.getchatuser(this.su.getLoginUser().username);
    }


    joinChatRoom() {
        if (this.ksChatUsers.length > 0) {
            // console.log(this.ksChatUsers);
            if (this.ksChatUsers.length === 1) {
                const iq = $iq({type: 'set', xmlns: 'jabber:client'})
                    .c('pubsub', {xmlns: 'http://jabber.org/protocol/pubsub'})
                    .c('publish', {node: 'storage:bookmarks'})
                    .c('item', {id: 'current'})
                    .c('storage', {xmlns: 'storage:bookmarks'})
                    .c('conference', {
                        autojoin: 'true',
                        jid: this.ksChatUsers[0].roomName + '@conference.rtc1',
                        name: this.ksChatUsers[0].groupName,
                    }).c('nick')
                    .t(XmppUtils.jid)
                XmppUtils.connection.sendIQ(iq);
            } else if (this.ksChatUsers.length === 2) {
                const iq = $iq({type: 'set', xmlns: 'jabber:client'})
                    .c('pubsub', {xmlns: 'http://jabber.org/protocol/pubsub'})
                    .c('publish', {node: 'storage:bookmarks'})
                    .c('item', {id: 'current'})
                    .c('storage', {xmlns: 'storage:bookmarks'})
                    .c('conference', {
                        autojoin: 'true',
                        jid: this.ksChatUsers[0].roomName + '@conference.rtc1',
                        name: this.ksChatUsers[0].groupName
                    })
                    .c('conference', {
                        autojoin: 'true',
                        jid: this.ksChatUsers[1].roomName + '@conference.rtc1',
                        name: this.ksChatUsers[1].groupName
                    });
                XmppUtils.connection.sendIQ(iq);
            } else if (this.ksChatUsers.length === 3) {
                const iq = $iq({type: 'set', xmlns: 'jabber:client'})
                    .c('pubsub', {xmlns: 'http://jabber.org/protocol/pubsub'})
                    .c('publish', {node: 'storage:bookmarks'})
                    .c('item', {id: 'current'})
                    .c('storage', {xmlns: 'storage:bookmarks'})
                    .c('conference', {
                        autojoin: 'true',
                        jid: this.ksChatUsers[0].roomName + '@conference.rtc1',
                        name: this.ksChatUsers[0].groupName
                    })
                    .c('conference', {
                        autojoin: 'true',
                        jid: this.ksChatUsers[1].roomName + '@conference.rtc1',
                        name: this.ksChatUsers[1].groupName
                    })
                    .c('conference', {
                        autojoin: 'true',
                        jid: this.ksChatUsers[2].roomName + '@conference.rtc1',
                        name: this.ksChatUsers[2].groupName
                    });
                XmppUtils.connection.sendIQ(iq);
            } else if (this.ksChatUsers.length === 4) {
                const iq = $iq({type: 'set', xmlns: 'jabber:client'})
                    .c('pubsub', {xmlns: 'http://jabber.org/protocol/pubsub'})
                    .c('publish', {node: 'storage:bookmarks'})
                    .c('item', {id: 'current'})
                    .c('storage', {xmlns: 'storage:bookmarks'})
                    .c('conference', {
                        autojoin: 'true',
                        jid: this.ksChatUsers[0].roomName + '@conference.rtc1',
                        name: this.ksChatUsers[0].groupName
                    })
                    .c('conference', {
                        autojoin: 'true',
                        jid: this.ksChatUsers[1].roomName + '@conference.rtc1',
                        name: this.ksChatUsers[1].groupName
                    })
                    .c('conference', {
                        autojoin: 'true',
                        jid: this.ksChatUsers[2].roomName + '@conference.rtc1',
                        name: this.ksChatUsers[2].groupName
                    })
                    .c('conference', {
                        autojoin: 'true',
                        jid: this.ksChatUsers[3].roomName + '@conference.rtc1',
                        name: this.ksChatUsers[3].groupName
                    });
                XmppUtils.connection.sendIQ(iq);
            } else if (this.ksChatUsers.length === 5) {
                const iq = $iq({type: 'set', xmlns: 'jabber:client'})
                    .c('pubsub', {xmlns: 'http://jabber.org/protocol/pubsub'})
                    .c('publish', {node: 'storage:bookmarks'})
                    .c('item', {id: 'current'})
                    .c('storage', {xmlns: 'storage:bookmarks'})
                    .c('conference', {
                        autojoin: 'true',
                        jid: this.ksChatUsers[0].roomName + '@conference.rtc1',
                        name: this.ksChatUsers[0].groupName
                    })
                    .c('conference', {
                        autojoin: 'true',
                        jid: this.ksChatUsers[1].roomName + '@conference.rtc1',
                        name: this.ksChatUsers[1].groupName
                    })
                    .c('conference', {
                        autojoin: 'true',
                        jid: this.ksChatUsers[2].roomName + '@conference.rtc1',
                        name: this.ksChatUsers[2].groupName
                    })
                    .c('conference', {
                        autojoin: 'true',
                        jid: this.ksChatUsers[3].roomName + '@conference.rtc1',
                        name: this.ksChatUsers[3].groupName
                    })
                    .c('conference', {
                        autojoin: 'true',
                        jid: this.ksChatUsers[4].roomName + '@conference.rtc1',
                        name: this.ksChatUsers[4].groupName
                    });
                XmppUtils.connection.sendIQ(iq);
            } else if (this.ksChatUsers.length === 6) {
                const iq = $iq({type: 'set', xmlns: 'jabber:client'})
                    .c('pubsub', {xmlns: 'http://jabber.org/protocol/pubsub'})
                    .c('publish', {node: 'storage:bookmarks'})
                    .c('item', {id: 'current'})
                    .c('storage', {xmlns: 'storage:bookmarks'})
                    .c('conference', {
                        autojoin: 'true',
                        jid: this.ksChatUsers[0].roomName + '@conference.rtc1',
                        name: this.ksChatUsers[0].groupName
                    })
                    .c('conference', {
                        autojoin: 'true',
                        jid: this.ksChatUsers[1].roomName + '@conference.rtc1',
                        name: this.ksChatUsers[1].groupName
                    })
                    .c('conference', {
                        autojoin: 'true',
                        jid: this.ksChatUsers[2].roomName + '@conference.rtc1',
                        name: this.ksChatUsers[2].groupName
                    })
                    .c('conference', {
                        autojoin: 'true',
                        jid: this.ksChatUsers[3].roomName + '@conference.rtc1',
                        name: this.ksChatUsers[3].groupName
                    })
                    .c('conference', {
                        autojoin: 'true',
                        jid: this.ksChatUsers[4].roomName + '@conference.rtc1',
                        name: this.ksChatUsers[4].groupName
                    })
                    .c('conference', {
                        autojoin: 'true',
                        jid: this.ksChatUsers[5].roomName + '@conference.rtc1',
                        name: this.ksChatUsers[5].groupName
                    });
                XmppUtils.connection.sendIQ(iq);
            } else if (this.ksChatUsers.length === 7) {
                const iq = $iq({type: 'set', xmlns: 'jabber:client'})
                    .c('pubsub', {xmlns: 'http://jabber.org/protocol/pubsub'})
                    .c('publish', {node: 'storage:bookmarks'})
                    .c('item', {id: 'current'})
                    .c('storage', {xmlns: 'storage:bookmarks'})
                    .c('conference', {
                        autojoin: 'true',
                        jid: this.ksChatUsers[0].roomName + '@conference.rtc1',
                        name: this.ksChatUsers[0].groupName
                    })
                    .c('conference', {
                        autojoin: 'true',
                        jid: this.ksChatUsers[1].roomName + '@conference.rtc1',
                        name: this.ksChatUsers[1].groupName
                    })
                    .c('conference', {
                        autojoin: 'true',
                        jid: this.ksChatUsers[2].roomName + '@conference.rtc1',
                        name: this.ksChatUsers[2].groupName
                    })
                    .c('conference', {
                        autojoin: 'true',
                        jid: this.ksChatUsers[3].roomName + '@conference.rtc1',
                        name: this.ksChatUsers[3].groupName
                    })
                    .c('conference', {
                        autojoin: 'true',
                        jid: this.ksChatUsers[4].roomName + '@conference.rtc1',
                        name: this.ksChatUsers[4].groupName
                    })
                    .c('conference', {
                        autojoin: 'true',
                        jid: this.ksChatUsers[5].roomName + '@conference.rtc1',
                        name: this.ksChatUsers[5].groupName
                    })
                    .c('conference', {
                        autojoin: 'true',
                        jid: this.ksChatUsers[6].roomName + '@conference.rtc1',
                        name: this.ksChatUsers[6].groupName
                    });
                XmppUtils.connection.sendIQ(iq);
            } else if (this.ksChatUsers.length === 8) {
                const iq = $iq({type: 'set', xmlns: 'jabber:client'})
                    .c('pubsub', {xmlns: 'http://jabber.org/protocol/pubsub'})
                    .c('publish', {node: 'storage:bookmarks'})
                    .c('item', {id: 'current'})
                    .c('storage', {xmlns: 'storage:bookmarks'})
                    .c('conference', {
                        autojoin: 'true',
                        jid: this.ksChatUsers[0].roomName + '@conference.rtc1',
                        name: this.ksChatUsers[0].groupName
                    })
                    .c('conference', {
                        autojoin: 'true',
                        jid: this.ksChatUsers[1].roomName + '@conference.rtc1',
                        name: this.ksChatUsers[1].groupName
                    })
                    .c('conference', {
                        autojoin: 'true',
                        jid: this.ksChatUsers[2].roomName + '@conference.rtc1',
                        name: this.ksChatUsers[2].groupName
                    })
                    .c('conference', {
                        autojoin: 'true',
                        jid: this.ksChatUsers[3].roomName + '@conference.rtc1',
                        name: this.ksChatUsers[3].groupName
                    })
                    .c('conference', {
                        autojoin: 'true',
                        jid: this.ksChatUsers[4].roomName + '@conference.rtc1',
                        name: this.ksChatUsers[4].groupName
                    })
                    .c('conference', {
                        autojoin: 'true',
                        jid: this.ksChatUsers[5].roomName + '@conference.rtc1',
                        name: this.ksChatUsers[5].groupName
                    })
                    .c('conference', {
                        autojoin: 'true',
                        jid: this.ksChatUsers[6].roomName + '@conference.rtc1',
                        name: this.ksChatUsers[6].groupName
                    })
                    .c('conference', {
                        autojoin: 'true',
                        jid: this.ksChatUsers[7].roomName + '@conference.rtc1',
                        name: this.ksChatUsers[7].groupName
                    });
                XmppUtils.connection.sendIQ(iq);
            } else if (this.ksChatUsers.length === 9) {
                const iq = $iq({type: 'set', xmlns: 'jabber:client'})
                    .c('pubsub', {xmlns: 'http://jabber.org/protocol/pubsub'})
                    .c('publish', {node: 'storage:bookmarks'})
                    .c('item', {id: 'current'})
                    .c('storage', {xmlns: 'storage:bookmarks'})
                    .c('conference', {
                        autojoin: 'true',
                        jid: this.ksChatUsers[0].roomName + '@conference.rtc1',
                        name: this.ksChatUsers[0].groupName
                    })
                    .c('conference', {
                        autojoin: 'true',
                        jid: this.ksChatUsers[1].roomName + '@conference.rtc1',
                        name: this.ksChatUsers[1].groupName
                    })
                    .c('conference', {
                        autojoin: 'true',
                        jid: this.ksChatUsers[2].roomName + '@conference.rtc1',
                        name: this.ksChatUsers[2].groupName
                    })
                    .c('conference', {
                        autojoin: 'true',
                        jid: this.ksChatUsers[3].roomName + '@conference.rtc1',
                        name: this.ksChatUsers[3].groupName
                    })
                    .c('conference', {
                        autojoin: 'true',
                        jid: this.ksChatUsers[4].roomName + '@conference.rtc1',
                        name: this.ksChatUsers[4].groupName
                    })
                    .c('conference', {
                        autojoin: 'true',
                        jid: this.ksChatUsers[5].roomName + '@conference.rtc1',
                        name: this.ksChatUsers[5].groupName
                    })
                    .c('conference', {
                        autojoin: 'true',
                        jid: this.ksChatUsers[6].roomName + '@conference.rtc1',
                        name: this.ksChatUsers[6].groupName
                    })
                    .c('conference', {
                        autojoin: 'true',
                        jid: this.ksChatUsers[7].roomName + '@conference.rtc1',
                        name: this.ksChatUsers[7].groupName
                    })
                    .c('conference', {
                        autojoin: 'true',
                        jid: this.ksChatUsers[8].roomName + '@conference.rtc1',
                        name: this.ksChatUsers[8].groupName
                    });
                XmppUtils.connection.sendIQ(iq);
            } else if (this.ksChatUsers.length === 10) {
                const iq = $iq({type: 'set', xmlns: 'jabber:client'})
                    .c('pubsub', {xmlns: 'http://jabber.org/protocol/pubsub'})
                    .c('publish', {node: 'storage:bookmarks'})
                    .c('item', {id: 'current'})
                    .c('storage', {xmlns: 'storage:bookmarks'})
                    .c('conference', {
                        autojoin: 'true',
                        jid: this.ksChatUsers[0].roomName + '@conference.rtc1',
                        name: this.ksChatUsers[0].groupName
                    })
                    .c('conference', {
                        autojoin: 'true',
                        jid: this.ksChatUsers[1].roomName + '@conference.rtc1',
                        name: this.ksChatUsers[1].groupName
                    })
                    .c('conference', {
                        autojoin: 'true',
                        jid: this.ksChatUsers[2].roomName + '@conference.rtc1',
                        name: this.ksChatUsers[2].groupName
                    })
                    .c('conference', {
                        autojoin: 'true',
                        jid: this.ksChatUsers[3].roomName + '@conference.rtc1',
                        name: this.ksChatUsers[3].groupName
                    })
                    .c('conference', {
                        autojoin: 'true',
                        jid: this.ksChatUsers[4].roomName + '@conference.rtc1',
                        name: this.ksChatUsers[4].groupName
                    })
                    .c('conference', {
                        autojoin: 'true',
                        jid: this.ksChatUsers[5].roomName + '@conference.rtc1',
                        name: this.ksChatUsers[5].groupName
                    })
                    .c('conference', {
                        autojoin: 'true',
                        jid: this.ksChatUsers[6].roomName + '@conference.rtc1',
                        name: this.ksChatUsers[6].groupName
                    })
                    .c('conference', {
                        autojoin: 'true',
                        jid: this.ksChatUsers[7].roomName + '@conference.rtc1',
                        name: this.ksChatUsers[7].groupName
                    })
                    .c('conference', {
                        autojoin: 'true',
                        jid: this.ksChatUsers[8].roomName + '@conference.rtc1',
                        name: this.ksChatUsers[8].groupName
                    })
                    .c('conference', {
                        autojoin: 'true',
                        jid: this.ksChatUsers[9].roomName + '@conference.rtc1',
                        name: this.ksChatUsers[9].groupName
                    });
                XmppUtils.connection.sendIQ(iq);
            } else if (this.ksChatUsers.length > 10) {
                return true;
            }
        }
    }

    //发送一对一聊天消息
    static async sendMessage(fromJid: string, toJid: string, message: string) {
        const msg = $msg({
            to: toJid,
            from: fromJid,
            type: 'chat',
            xmlns: "jabber:client"
        }).c("body", null, message);
        XmppUtils.connection.send(msg.tree());
        XmppUtils.connection.send($pres().tree());
    }

    //发送一对一聊天文件
    static async sendFile(fromJid: string, toJid: string, type: string, types: string, filePreviewUrl: string, fileDownloadUrl: string) {
        const msg = $msg({
            to: toJid,
            from: fromJid,
            type: 'chat',
            xmlns: "jabber:client",
            types: types,
            filePreviewUrl: filePreviewUrl,
            fileDownloadUrl: fileDownloadUrl
        }).c("body", null, type);
        this.connection.send(msg.tree());
        this.connection.send($pres().tree());
    }

    //发送一对一已读消息
    static async sendRead(fromJid: string, toJid: string) {
        const msg = $msg({
            to: toJid,
            from: fromJid,
            type: 'headline',
            xmlns: "jabber:client"
        }).c("body", null, '#*已读#');
        XmppUtils.connection.send(msg.tree());
        XmppUtils.connection.send($pres().tree());
    }

    //发送群聊消息
    static async sendGroupMsg(fromJid: string, groupJid: string, message: string) {
        const msg = $msg({
            from: fromJid,
            to: groupJid,
            type: 'groupchat',
            xmlns: 'jabber:client'
        }).c("body", null, message);
        XmppUtils.connection.send(msg.tree());
        XmppUtils.connection.send($pres().tree());
    }

}

//     sendImg(otherId, myselfId, message) {
//         if (connected) {
//             var msg = $msg({
//                 to: otherId + '@openfire.cn',
//                 from: myselfId + '@openfire.cn',
//                 type: 'chat',
//                 xmlns: "jabber:client"
//             }).c("body", null, message);
//             XmppUtils.connection.send(msg.tree());
//             XmppUtils.connection.send($pres().tree());
//         }
//     }
//
//
// // 添加好友
//     getFriend(name) {
//         XmppUtils.connection.send($pres({ to: name + '@openfire.cn', type: "subscribe" }));
//     }
//
// // 收到好友请求
//     on_subscription_request(stanza) {
//         if (stanza.getAttribute("type") == "subscribe") {
//             var from = stanza.getAttribute("from").match(/(\S*)@/)[1]
//             addFriend_warn.push(from)
//         }
//         addFriend_warn = Array.from(new Set(addFriend_warn));
//     }
//
// // 接受邀请
//     on_subscription_response(name) {
//         XmppUtils.connection.send($pres({ to: name + '@openfire.cn', type: "subscribed" }));
//     }
// // 拒绝邀请
//     on_subscription_reject(name) {
//         XmppUtils.connection.send($pres({ to: name + '@openfire.cn', type: "unsubscribed" }));
//     }
// // 删除好友
//     on_subscription_delete(name) {
//         XmppUtils.connection.send($pres({ to: name + '@openfire.cn', type: "unsubscribe" }));
//     }

